import Hero from "../components/Hero";
import SearchBar from "../components/SearchBar";
import PopularDestinations from "../components/PopularDestinations";
import TopRatedHotels from "../components/TopRatedHotels";
import HotelList from "../components/HotelList";
import WhyChooseUs from "../components/WhyChooseUs";
import BlogSection from "../components/BlogSection";
import Testimonials from "../components/Testimonials";
import TrustedPartners from "../components/TrustedPartners";
import CTASection from "../components/CTASection";
import heroImg from "../assests/images/hero.jpg";

export default function Home() {
  return (
    <div>

      {/* HERO */}
      <Hero
        variant="home"
        title="Find Your Perfect Stay"
        subtitle="Explore the best hotels, resorts, and travel experiences across top destinations worldwide."
        backgroundImage={heroImg}
      />

      {/* SEARCH */}
      <div className="relative z-20">
        <SearchBar />
      </div>

      {/* SECTIONS */}
      <PopularDestinations limit={4} showViewAllButton={true} />
      <TopRatedHotels limit={3} />
      <HotelList showSidebar={false} limit={6} showViewAllButton={true} showBanner={false} showHeading={true} />
      <WhyChooseUs />
      <BlogSection />
      <Testimonials />
      <TrustedPartners />
      <CTASection />

    </div>
  );
}